import { v4 as uuidv4 } from "uuid";

const VISITOR_ID_KEY = "kudavgorod-visitor-id";
const LEGACY_VISITOR_ID_KEY = "kudgorod-visitor-id";

export function getOrCreateVisitorId(): string {
  try {
    const existing =
      localStorage.getItem(VISITOR_ID_KEY) ??
      localStorage.getItem(LEGACY_VISITOR_ID_KEY);
    if (existing) {
      if (!localStorage.getItem(VISITOR_ID_KEY) && localStorage.getItem(LEGACY_VISITOR_ID_KEY)) {
        localStorage.setItem(VISITOR_ID_KEY, existing);
      }
      return existing;
    }

    const id = uuidv4();
    localStorage.setItem(VISITOR_ID_KEY, id);
    return id;
  } catch {
    return uuidv4();
  }
}

export function getVisitorPostBody(): { visitorId: string } {
  return { visitorId: getOrCreateVisitorId() };
}
